import React from 'react';
import { bool, func, number, string } from 'prop-types';
import compose from 'lodash/flowRight';
import { useFeatureFlags, useGTM } from 'hooks';
import { Chip } from 'components';
import { withInCategorySearch, withListingType } from 'connectors';
import { category as categoryUtils } from 'utils';
import { getUpdateInfos } from './utils';

export const CategoryChip = ({
    active,
    imageUrl,
    label,
    url,
    id,
    level,
    slug,
    refine,
    updateListingData,
    rank,
    nbHits,
    searchQuery,
}) => {
    const [, pushToGTM] = useGTM();
    const [{ hasSPABehaviourWithNoTransition }] = useFeatureFlags({
        hasSPABehaviourWithNoTransition: 'relevance.react.spa.with.transition',
    });
    const handleClick = e => {
        if (hasSPABehaviourWithNoTransition) {
            e.preventDefault();
            const { refinement, listingData } = getUpdateInfos({
                id,
                isChipActive: active,
                level,
                slug,
            });
            refine(refinement);
            updateListingData(listingData);
        }
        if (!active) {
            pushToGTM({
                event: 'scope_search_to_a_category',
                category_position: rank,
                category_name: label,
                category_id: id,
                number_of_results: nbHits,
                search_query: searchQuery,
            });
        }
    };

    return (
        <li className="intra-category__filter">
            <Chip
                extraClassName="intra-category__filter-link"
                label={categoryUtils.truncateCategoryName(label)}
                imageUrl={active ? '' : imageUrl}
                active={active}
                deletable={active}
                url={url}
                onClick={handleClick}
            />
        </li>
    );
};

CategoryChip.propTypes = {
    active: bool,
    imageUrl: string,
    label: string.isRequired,
    id: number.isRequired,
    level: number,
    rank: number,
    url: string,
    slug: string,
    refine: func.isRequired,
    updateListingData: func.isRequired,
    nbHits: number,
    searchQuery: string,
};

CategoryChip.defaultProps = {
    active: false,
    imageUrl: '',
    level: undefined,
    slug: undefined,
    url: '',
    rank: null,
    nbHits: 0,
    searchQuery: '',
};

CategoryChip.displayName = 'CategoryChip';

export default compose(withInCategorySearch, withListingType)(CategoryChip);
